import { render, staticRenderFns } from "./PasswordChallenge.vue?vue&type=template&id=0cc1b5c4&scoped=true"
import script from "./PasswordChallenge.vue?vue&type=script&lang=js"
export * from "./PasswordChallenge.vue?vue&type=script&lang=js"
import style0 from "./PasswordChallenge.vue?vue&type=style&index=0&id=0cc1b5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc1b5c4",
  null
  
)

export default component.exports